// // // // src/pages/admin/PendingCompanyProfileUpdatesPage.jsx
// // // import React, { useEffect, useState } from "react";
// // // import {
// // //   getPendingCompanyUpdates,
// // //   approveCompanyProfileUpdate,
// // //   rejectCompanyProfileUpdate,
// // // } from "../../../services/adminService"; // Adjusted path
// // // import {
// // //   Button,
// // //   Table,
// // //   Spinner,
// // //   Alert,
// // //   Badge,
// // //   Modal,
// // //   Row,
// // //   Col,
// // //   ListGroup,
// // // } from "react-bootstrap";
// // // import { format } from "date-fns"; // For formatting dates, install if not present: npm install date-fns

// // // const PendingCompanyProfileUpdatesPage = () => {
// // //   const [pendingCompanies, setPendingCompanies] = useState([]);
// // //   const [loading, setLoading] = useState(false);
// // //   const [error, setError] = useState("");
// // //   const [selectedCompanyForReview, setSelectedCompanyForReview] = useState(null);
// // //   const [showReviewModal, setShowReviewModal] = useState(false);
// // //   const [actionLoading, setActionLoading] = useState(false); // For approve/reject actions

// // //   const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

// // //   const fetchPendingUpdates = async () => {
// // //     setLoading(true);
// // //     setError("");
// // //     try {
// // //       const res = await getPendingCompanyUpdates();
// // //       // Filter for companies with actual pendingProfileUpdates to display
// // //       const filtered = res.data.filter(
// // //         (company) => company.companyStatus === "pending_update" && company.pendingProfileUpdates
// // //       );
// // //       setPendingCompanies(filtered || []);
// // //     } catch (err) {
// // //       setError(
// // //         err.response?.data?.message || "Failed to fetch pending company updates."
// // //       );
// // //       console.error("Error fetching pending company updates:", err);
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     fetchPendingUpdates();
// // //   }, []);

// // //   const handleReviewClick = (company) => {
// // //     setSelectedCompanyForReview(company);
// // //     setShowReviewModal(true);
// // //   };

// // //   const handleCloseReviewModal = () => {
// // //     setSelectedCompanyForReview(null);
// // //     setShowReviewModal(false);
// // //     setError(""); // Clear any previous errors
// // //   };

// // //   const handleApproveUpdate = async () => {
// // //     if (!selectedCompanyForReview) return;
// // //     setActionLoading(true);
// // //     setError("");
// // //     try {
// // //       await approveCompanyProfileUpdate(selectedCompanyForReview._id);
// // //       fetchPendingUpdates(); // Refresh the list
// // //       handleCloseReviewModal();
// // //     } catch (err) {
// // //       setError(
// // //         err.response?.data?.message || "Failed to approve company update."
// // //       );
// // //       console.error("Error approving update:", err);
// // //     } finally {
// // //       setActionLoading(false);
// // //     }
// // //   };

// // //   const handleRejectUpdate = async () => {
// // //     if (!selectedCompanyForReview) return;
// // //     setActionLoading(true);
// // //     setError("");
// // //     try {
// // //       await rejectCompanyProfileUpdate(selectedCompanyForReview._id);
// // //       fetchPendingUpdates(); // Refresh the list
// // //       handleCloseReviewModal();
// // //     } catch (err) {
// // //       setError(
// // //         err.response?.data?.message || "Failed to reject company update."
// // //       );
// // //       console.error("Error rejecting update:", err);
// // //     } finally {
// // //       setActionLoading(false);
// // //     }
// // //   };

// // //   const renderValueComparison = (field, originalValue, pendingValue, type = 'text') => {
// // //     const isChanged = JSON.stringify(originalValue) !== JSON.stringify(pendingValue);
// // //     const renderContent = (value) => {
// // //       if (value === null || value === undefined || value === '') return <em className="text-muted">N/A</em>;
      
// // //       switch (type) {
// // //         case 'url':
// // //           return <a href={value} target="_blank" rel="noopener noreferrer">{value}</a>;
// // //         case 'array':
// // //           return Array.isArray(value) && value.length > 0 ? value.join(', ') : <em className="text-muted">None</em>;
// // //         case 'object-name': // For category/subcategory objects
// // //             return value?.name || <em className="text-muted">N/A</em>;
// // //         case 'businessTimings':
// // //             if (value && typeof value === 'object') {
// // //                 return (
// // //                     <ListGroup variant="flush" className="p-0">
// // //                         {daysOfWeek.map(day => (
// // //                             <ListGroup.Item key={day} className="d-flex justify-content-between text-capitalize p-1">
// // //                                 <strong>{day}:</strong> <span>{value[day]?.open || 'Closed'} - {value[day]?.close || ''}</span>
// // //                             </ListGroup.Item>
// // //                         ))}
// // //                     </ListGroup>
// // //                 );
// // //             }
// // //             return <em className="text-muted">N/A</em>;
// // //         case 'document-link':
// // //              return <a href={value} target="_blank" rel="noopener noreferrer">View Document</a>;
// // //         case 'image-link':
// // //             return <a href={value} target="_blank" rel="noopener noreferrer"><img src={value} alt="Current" style={{maxWidth: '80px', maxHeight: '80px'}} /></a>;
// // //         case 'image-array':
// // //             return Array.isArray(value) && value.length > 0 ? (
// // //                 <div className="d-flex flex-wrap gap-2">
// // //                     {value.map((img, idx) => (
// // //                         <a key={idx} href={img} target="_blank" rel="noopener noreferrer"><img src={img} alt={`Image ${idx+1}`} style={{maxWidth: '50px', maxHeight: '50px'}} /></a>
// // //                     ))}
// // //                 </div>
// // //             ) : <em className="text-muted">None</em>;
// // //         default:
// // //           return value.toString();
// // //       }
// // //     };

// // //     return (
// // //       <Col xs={12} className="mb-2">
// // //         <strong className="text-capitalize">{field.replace(/([A-Z])/g, ' $1').trim()}:</strong>
// // //         <Row className="gx-2">
// // //           <Col xs={6}>
// // //             <small className="d-block text-muted">Current Value:</small>
// // //             <div className={`p-2 border rounded ${isChanged ? 'bg-light' : ''}`}>
// // //               {renderContent(originalValue)}
// // //             </div>
// // //           </Col>
// // //           <Col xs={6}>
// // //             <small className="d-block text-muted">Proposed Value:</small>
// // //             <div className={`p-2 border rounded ${isChanged ? 'bg-warning-subtle fw-bold' : ''}`}>
// // //               {renderContent(pendingValue)}
// // //             </div>
// // //           </Col>
// // //         </Row>
// // //       </Col>
// // //     );
// // //   };

// // //   return (
// // //     <div className="container mt-4">
// // //       <h2 className="mb-4 text-center fw-bold">
// // //         🔄 Company Profile Update Requests
// // //       </h2>

// // //       {error && <Alert variant="danger">{error}</Alert>}

// // //       {loading ? (
// // //         <div className="text-center">
// // //           <Spinner animation="border" />
// // //           <p className="mt-2">Fetching pending updates...</p>
// // //         </div>
// // //       ) : (
// // //         <Table
// // //           striped
// // //           bordered
// // //           hover
// // //           responsive
// // //           className="align-middle text-center shadow-sm"
// // //         >
// // //           <thead className="table-dark">
// // //             <tr>
// // //               <th>#</th>
// // //               <th>Company Name</th>
// // //               <th>Email</th>
// // //               <th>Registered By</th>
// // //               <th>Request Date</th>
// // //               <th>Actions</th>
// // //             </tr>
// // //           </thead>
// // //           <tbody>
// // //             {pendingCompanies.length > 0 ? (
// // //               pendingCompanies.map((company, index) => (
// // //                 <tr key={company._id}>
// // //                   <td>{index + 1}</td>
// // //                   <td>{company.name}</td>
// // //                   <td>{company.email}</td>
// // //                   <td>{company.registeredBy?.name || "N/A"}</td>
// // //                   <td>
// // //                     {company.updatedAt ? (
// // //                       format(new Date(company.updatedAt), "PPP p")
// // //                     ) : (
// // //                       <em className="text-muted">N/A</em>
// // //                     )}
// // //                   </td>
// // //                   <td>
// // //                     <Button
// // //                       size="sm"
// // //                       variant="info"
// // //                       onClick={() => handleReviewClick(company)}
// // //                     >
// // //                       📝 Review Update
// // //                     </Button>
// // //                   </td>
// // //                 </tr>
// // //               ))
// // //             ) : (
// // //               <tr>
// // //                 <td colSpan="6" className="text-center text-muted">
// // //                   No pending company profile updates found.
// // //                 </td>
// // //               </tr>
// // //             )}
// // //           </tbody>
// // //         </Table>
// // //       )}

// // //       {/* Review Update Modal */}
// // //       <Modal
// // //         show={showReviewModal}
// // //         onHide={handleCloseReviewModal}
// // //         size="lg"
// // //         centered
// // //         scrollable
// // //       >
// // //         <Modal.Header closeButton>
// // //           <Modal.Title>Review Company Profile Update</Modal.Title>
// // //         </Modal.Header>
// // //         <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
// // //           {selectedCompanyForReview && (
// // //             <>
// // //               {error && <Alert variant="danger">{error}</Alert>}
// // //               <h4 className="mb-3 text-primary">
// // //                 {selectedCompanyForReview.name}
// // //                 <Badge bg="warning" className="ms-2">
// // //                   Pending Update
// // //                 </Badge>
// // //               </h4>

// // //               <Alert variant="info">
// // //                 Below, you will see the **Current Approved Value** on the left and the **Proposed New Value** on the right.
// // //                 Changed fields are highlighted.
// // //               </Alert>

// // //               <Row className="mb-4">
// // //                 {/* Dynamically render comparisons for common fields */}
// // //                 {renderValueComparison('name', selectedCompanyForReview.name, selectedCompanyForReview.pendingProfileUpdates.name)}
// // //                 {renderValueComparison('tagline', selectedCompanyForReview.tagline, selectedCompanyForReview.pendingProfileUpdates.tagline)}
// // //                 {renderValueComparison('description', selectedCompanyForReview.description, selectedCompanyForReview.pendingProfileUpdates.description)}
// // //                 {renderValueComparison('email', selectedCompanyForReview.email, selectedCompanyForReview.pendingProfileUpdates.email)}
// // //                 {renderValueComparison('phone', selectedCompanyForReview.phone, selectedCompanyForReview.pendingProfileUpdates.phone)}
// // //                 {renderValueComparison('website', selectedCompanyForReview.website, selectedCompanyForReview.pendingProfileUpdates.website, 'url')}
// // //                 {renderValueComparison('address', selectedCompanyForReview.address, selectedCompanyForReview.pendingProfileUpdates.address)}
// // //                 {renderValueComparison('city', selectedCompanyForReview.city, selectedCompanyForReview.pendingProfileUpdates.city)}
// // //                 {renderValueComparison('state', selectedCompanyForReview.state, selectedCompanyForReview.pendingProfileUpdates.state)}
// // //                 {renderValueComparison('country', selectedCompanyForReview.country, selectedCompanyForReview.pendingProfileUpdates.country)}
// // //                 {renderValueComparison('gstNumber', selectedCompanyForReview.gstNumber, selectedCompanyForReview.pendingProfileUpdates.gstNumber)}
// // //                 {renderValueComparison('aadhaarNumber', selectedCompanyForReview.aadhaarNumber, selectedCompanyForReview.pendingProfileUpdates.aadhaarNumber)}
// // //                 {renderValueComparison('googleMapsLink', selectedCompanyForReview.googleMapsLink, selectedCompanyForReview.pendingProfileUpdates.googleMapsLink, 'url')}
// // //                 {renderValueComparison('keywords', selectedCompanyForReview.keywords, selectedCompanyForReview.pendingProfileUpdates.keywords, 'array')}
// // //                 {renderValueComparison('socialLinks', selectedCompanyForReview.socialLinks, selectedCompanyForReview.pendingProfileUpdates.socialLinks, 'array')}
// // //                 {renderValueComparison('category', selectedCompanyForReview.category, selectedCompanyForReview.pendingProfileUpdates.category, 'object-name')}
// // //                 {renderValueComparison('subCategory', selectedCompanyForReview.subCategory, selectedCompanyForReview.pendingProfileUpdates.subCategory, 'object-name')}
// // //                 {renderValueComparison('companyType', selectedCompanyForReview.companyType, selectedCompanyForReview.pendingProfileUpdates.companyType)}
// // //                 {renderValueComparison('logo', selectedCompanyForReview.logo, selectedCompanyForReview.pendingProfileUpdates.logo, 'image-link')}
// // //                 {renderValueComparison('banner', selectedCompanyForReview.banner, selectedCompanyForReview.pendingProfileUpdates.banner, 'image-array')}
// // //                 {renderValueComparison('aadhaarImage', selectedCompanyForReview.aadhaarImage, selectedCompanyForReview.pendingProfileUpdates.aadhaarImage, 'document-link')}
// // //                 {renderValueComparison('panImage', selectedCompanyForReview.panImage, selectedCompanyForReview.pendingProfileUpdates.panImage, 'document-link')}
// // //                 {renderValueComparison('electricityBillImage', selectedCompanyForReview.electricityBillImage, selectedCompanyForReview.pendingProfileUpdates.electricityBillImage, 'document-link')}
// // //                 {renderValueComparison('passportPhoto', selectedCompanyForReview.passportPhoto, selectedCompanyForReview.pendingProfileUpdates.passportPhoto, 'document-link')}
// // //                 {renderValueComparison('businessTimings', selectedCompanyForReview.businessTimings, selectedCompanyForReview.pendingProfileUpdates.businessTimings, 'businessTimings')}


// // //                 {/* You might need to add more specific comparisons for complex objects or arrays like products, services if they are part of pendingProfileUpdates */}

// // //               </Row>
// // //             </>
// // //           )}
// // //         </Modal.Body>
// // //         <Modal.Footer>
// // //           <Button variant="secondary" onClick={handleCloseReviewModal} disabled={actionLoading}>
// // //             Close
// // //           </Button>
// // //           <Button
// // //             variant="danger"
// // //             onClick={handleRejectUpdate}
// // //             disabled={actionLoading}
// // //             className="me-2"
// // //           >
// // //             {actionLoading ? (
// // //               <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
// // //             ) : (
// // //               "❌ Reject Update"
// // //             )}
// // //           </Button>
// // //           <Button
// // //             variant="success"
// // //             onClick={handleApproveUpdate}
// // //             disabled={actionLoading}
// // //           >
// // //             {actionLoading ? (
// // //               <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
// // //             ) : (
// // //               "✅ Approve Update"
// // //             )}
// // //           </Button>
// // //         </Modal.Footer>
// // //       </Modal>
// // //     </div>
// // //   );
// // // };

// // // export default PendingCompanyProfileUpdatesPage;



// // // src/pages/admin/PendingCompanyProfileUpdatesPage.jsx
// // import React, { useEffect, useState } from "react";
// // import {
// //   getPendingCompanyUpdates,
// //   approveCompanyProfileUpdate,
// //   rejectCompanyProfileUpdate,
// // } from "../../../services/adminService"; // Adjusted path
// // import {
// //   Button,
// //   Table,
// //   Spinner,
// //   Alert,
// //   Badge,
// //   Modal,
// //   Row,
// //   Col,
// //   ListGroup,
// // } from "react-bootstrap";
// // import { format } from "date-fns"; // For formatting dates, install if not present: npm install date-fns
// // import { useNavigate } from "react-router-dom"; // Import useNavigate

// // const PendingCompanyProfileUpdatesPage = () => {
// //   const [pendingCompanies, setPendingCompanies] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState("");
// //   const [selectedCompanyForReview, setSelectedCompanyForReview] = useState(null);
// //   const [showReviewModal, setShowReviewModal] = useState(false);
// //   const [actionLoading, setActionLoading] = useState(false); // For approve/reject actions
// //   const navigate = useNavigate(); // Initialize useNavigate

// //   const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

// //   const fetchPendingUpdates = async () => {
// //     setLoading(true);
// //     setError("");
// //     try {
// //       const res = await getPendingCompanyUpdates();
// //       // Filter for companies with actual pendingProfileUpdates to display
// //       const filtered = res.data.filter(
// //         (company) => company.companyStatus === "pending_update" && company.pendingProfileUpdates
// //       );
// //       setPendingCompanies(filtered || []);
// //     } catch (err) {
// //       setError(
// //         err.response?.data?.message || "Failed to fetch pending company updates."
// //       );
// //       console.error("Error fetching pending company updates:", err);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchPendingUpdates();
// //   }, []);

// //   const handleReviewClick = (company) => {
// //     setSelectedCompanyForReview(company);
// //     setShowReviewModal(true);
// //   };

// //   const handleCloseReviewModal = () => {
// //     setSelectedCompanyForReview(null);
// //     setShowReviewModal(false);
// //     setError(""); // Clear any previous errors
// //   };

// //   const handleApproveUpdate = async () => {
// //     if (!selectedCompanyForReview) return;
// //     setActionLoading(true);
// //     setError("");
// //     try {
// //       await approveCompanyProfileUpdate(selectedCompanyForReview._id);
// //       fetchPendingUpdates(); // Refresh the list
// //       handleCloseReviewModal();
// //     } catch (err) {
// //       setError(
// //         err.response?.data?.message || "Failed to approve company update."
// //       );
// //       console.error("Error approving update:", err);
// //     } finally {
// //       setActionLoading(false);
// //     }
// //   };

// //   const handleRejectUpdate = async () => {
// //     if (!selectedCompanyForReview) return;
// //     setActionLoading(true);
// //     setError("");
// //     try {
// //       await rejectCompanyProfileUpdate(selectedCompanyForReview._id);
// //       fetchPendingUpdates(); // Refresh the list
// //       handleCloseReviewModal();
// //     } catch (err) {
// //       setError(
// //         err.response?.data?.message || "Failed to reject company update."
// //       );
// //       console.error("Error rejecting update:", err);
// //     } finally {
// //       setActionLoading(false);
// //     }
// //   };

// //   const renderValueComparison = (field, originalValue, pendingValue, type = 'text') => {
// //     const isChanged = JSON.stringify(originalValue) !== JSON.stringify(pendingValue);
// //     const renderContent = (value) => {
// //       if (value === null || value === undefined || value === '') return <em className="text-muted">N/A</em>;
      
// //       switch (type) {
// //         case 'url':
// //           return <a href={value} target="_blank" rel="noopener noreferrer">{value}</a>;
// //         case 'array':
// //           return Array.isArray(value) && value.length > 0 ? value.join(', ') : <em className="text-muted">None</em>;
// //         case 'object-name': // For category/subcategory objects
// //             return value?.name || <em className="text-muted">N/A</em>;
// //         case 'businessTimings':
// //             if (value && typeof value === 'object') {
// //                 return (
// //                     <ListGroup variant="flush" className="p-0">
// //                         {daysOfWeek.map(day => (
// //                             <ListGroup.Item key={day} className="d-flex justify-content-between text-capitalize p-1">
// //                                 <strong>{day}:</strong> <span>{value[day]?.open || 'Closed'} - {value[day]?.close || ''}</span>
// //                             </ListGroup.Item>
// //                         ))}
// //                     </ListGroup>
// //                 );
// //             }
// //             return <em className="text-muted">N/A</em>;
// //         case 'document-link':
// //              return <a href={value} target="_blank" rel="noopener noreferrer">View Document</a>;
// //         case 'image-link':
// //             return <a href={value} target="_blank" rel="noopener noreferrer"><img src={value} alt="Current" style={{maxWidth: '80px', maxHeight: '80px'}} /></a>;
// //         case 'image-array':
// //             return Array.isArray(value) && value.length > 0 ? (
// //                 <div className="d-flex flex-wrap gap-2">
// //                     {value.map((img, idx) => (
// //                         <a key={idx} href={img} target="_blank" rel="noopener noreferrer"><img src={img} alt={`Image ${idx+1}`} style={{maxWidth: '50px', maxHeight: '50px'}} /></a>
// //                     ))}
// //                 </div>
// //             ) : <em className="text-muted">None</em>;
// //         default:
// //           return value.toString();
// //       }
// //     };

// //     return (
// //       <Col xs={12} className="mb-2">
// //         <strong className="text-capitalize">{field.replace(/([A-Z])/g, ' $1').trim()}:</strong>
// //         <Row className="gx-2">
// //           <Col xs={6}>
// //             <small className="d-block text-muted">Current Value:</small>
// //             <div className={`p-2 border rounded ${isChanged ? 'bg-light' : ''}`}>
// //               {renderContent(originalValue)}
// //             </div>
// //           </Col>
// //           <Col xs={6}>
// //             <small className="d-block text-muted">Proposed Value:</small>
// //             <div className={`p-2 border rounded ${isChanged ? 'bg-warning-subtle fw-bold' : ''}`}>
// //               {renderContent(pendingValue)}
// //             </div>
// //           </Col>
// //         </Row>
// //       </Col>
// //     );
// //   };

// //   return (
// //     <div className="container mt-4">
// //       <div className="d-flex justify-content-between align-items-center mb-4">
// //         <h2 className="fw-bold">
// //           🔄 Company Profile Update Requests
// //         </h2>
// //         <Button
// //           variant="primary"
// //           onClick={() => navigate('/AdminProductManagementPage')} // Navigate to AdminProductManagementPage
// //         >
// //           Manage All Products
// //         </Button>
// //       </div>

// //       {error && <Alert variant="danger">{error}</Alert>}

// //       {loading ? (
// //         <div className="text-center">
// //           <Spinner animation="border" />
// //           <p className="mt-2">Fetching pending updates...</p>
// //         </div>
// //       ) : (
// //         <Table
// //           striped
// //           bordered
// //           hover
// //           responsive
// //           className="align-middle text-center shadow-sm"
// //         >
// //           <thead className="table-dark">
// //             <tr>
// //               <th>#</th>
// //               <th>Company Name</th>
// //               <th>Email</th>
// //               <th>Registered By</th>
// //               <th>Request Date</th>
// //               <th>Actions</th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             {pendingCompanies.length > 0 ? (
// //               pendingCompanies.map((company, index) => (
// //                 <tr key={company._id}>
// //                   <td>{index + 1}</td>
// //                   <td>{company.name}</td>
// //                   <td>{company.email}</td>
// //                   <td>{company.registeredBy?.name || "N/A"}</td>
// //                   <td>
// //                     {company.updatedAt ? (
// //                       format(new Date(company.updatedAt), "PPP p")
// //                     ) : (
// //                       <em className="text-muted">N/A</em>
// //                     )}
// //                   </td>
// //                   <td>
// //                     <Button
// //                       size="sm"
// //                       variant="info"
// //                       onClick={() => handleReviewClick(company)}
// //                     >
// //                       📝 Review Update
// //                     </Button>
// //                   </td>
// //                 </tr>
// //               ))
// //             ) : (
// //               <tr>
// //                 <td colSpan="6" className="text-center text-muted">
// //                   No pending company profile updates found.
// //                 </td>
// //               </tr>
// //             )}
// //           </tbody>
// //         </Table>
// //       )}

// //       {/* Review Update Modal */}
// //       <Modal
// //         show={showReviewModal}
// //         onHide={handleCloseReviewModal}
// //         size="lg"
// //         centered
// //         scrollable
// //       >
// //         <Modal.Header closeButton>
// //           <Modal.Title>Review Company Profile Update</Modal.Title>
// //         </Modal.Header>
// //         <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
// //           {selectedCompanyForReview && (
// //             <>
// //               {error && <Alert variant="danger">{error}</Alert>}
// //               <h4 className="mb-3 text-primary">
// //                 {selectedCompanyForReview.name}
// //                 <Badge bg="warning" className="ms-2">
// //                   Pending Update
// //                 </Badge>
// //               </h4>

// //               <Alert variant="info">
// //                 Below, you will see the **Current Approved Value** on the left and the **Proposed New Value** on the right.
// //                 Changed fields are highlighted.
// //               </Alert>

// //               <Row className="mb-4">
// //                 {/* Dynamically render comparisons for common fields */}
// //                 {renderValueComparison('name', selectedCompanyForReview.name, selectedCompanyForReview.pendingProfileUpdates.name)}
// //                 {renderValueComparison('tagline', selectedCompanyForReview.tagline, selectedCompanyForReview.pendingProfileUpdates.tagline)}
// //                 {renderValueComparison('description', selectedCompanyForReview.description, selectedCompanyForReview.pendingProfileUpdates.description)}
// //                 {renderValueComparison('email', selectedCompanyForReview.email, selectedCompanyForReview.pendingProfileUpdates.email)}
// //                 {renderValueComparison('phone', selectedCompanyForReview.phone, selectedCompanyForReview.pendingProfileUpdates.phone)}
// //                 {renderValueComparison('website', selectedCompanyForReview.website, selectedCompanyForReview.pendingProfileUpdates.website, 'url')}
// //                 {renderValueComparison('address', selectedCompanyForReview.address, selectedCompanyForReview.pendingProfileUpdates.address)}
// //                 {renderValueComparison('city', selectedCompanyForReview.city, selectedCompanyForReview.pendingProfileUpdates.city)}
// //                 {renderValueComparison('state', selectedCompanyForReview.state, selectedCompanyForReview.pendingProfileUpdates.state)}
// //                 {renderValueComparison('country', selectedCompanyForReview.country, selectedCompanyForReview.pendingProfileUpdates.country)}
// //                 {renderValueComparison('gstNumber', selectedCompanyForReview.gstNumber, selectedCompanyForReview.pendingProfileUpdates.gstNumber)}
// //                 {renderValueComparison('aadhaarNumber', selectedCompanyForReview.aadhaarNumber, selectedCompanyForReview.pendingProfileUpdates.aadhaarNumber)}
// //                 {renderValueComparison('googleMapsLink', selectedCompanyForReview.googleMapsLink, selectedCompanyForReview.pendingProfileUpdates.googleMapsLink, 'url')}
// //                 {renderValueComparison('keywords', selectedCompanyForReview.keywords, selectedCompanyForReview.pendingProfileUpdates.keywords, 'array')}
// //                 {renderValueComparison('socialLinks', selectedCompanyForReview.socialLinks, selectedCompanyForReview.pendingProfileUpdates.socialLinks, 'array')}
// //                 {renderValueComparison('category', selectedCompanyForReview.category, selectedCompanyForReview.pendingProfileUpdates.category, 'object-name')}
// //                 {renderValueComparison('subCategory', selectedCompanyForReview.subCategory, selectedCompanyForReview.pendingProfileUpdates.subCategory, 'object-name')}
// //                 {renderValueComparison('companyType', selectedCompanyForReview.companyType, selectedCompanyForReview.pendingProfileUpdates.companyType)}
// //                 {renderValueComparison('logo', selectedCompanyForReview.logo, selectedCompanyForReview.pendingProfileUpdates.logo, 'image-link')}
// //                 {renderValueComparison('banner', selectedCompanyForReview.banner, selectedCompanyForReview.pendingProfileUpdates.banner, 'image-array')}
// //                 {renderValueComparison('aadhaarImage', selectedCompanyForReview.aadhaarImage, selectedCompanyForReview.pendingProfileUpdates.aadhaarImage, 'document-link')}
// //                 {renderValueComparison('panImage', selectedCompanyForReview.panImage, selectedCompanyForReview.pendingProfileUpdates.panImage, 'document-link')}
// //                 {renderValueComparison('electricityBillImage', selectedCompanyForReview.electricityBillImage, selectedCompanyForReview.pendingProfileUpdates.electricityBillImage, 'document-link')}
// //                 {renderValueComparison('passportPhoto', selectedCompanyForReview.passportPhoto, selectedCompanyForReview.pendingProfileUpdates.passportPhoto, 'document-link')}
// //                 {renderValueComparison('businessTimings', selectedCompanyForReview.businessTimings, selectedCompanyForReview.pendingProfileUpdates.businessTimings, 'businessTimings')}


// //                 {/* You might need to add more specific comparisons for complex objects or arrays like products, services if they are part of pendingProfileUpdates */}

// //               </Row>
// //             </>
// //           )}
// //         </Modal.Body>
// //         <Modal.Footer>
// //           <Button variant="secondary" onClick={handleCloseReviewModal} disabled={actionLoading}>
// //             Close
// //           </Button>
// //           <Button
// //             variant="danger"
// //             onClick={handleRejectUpdate}
// //             disabled={actionLoading}
// //             className="me-2"
// //           >
// //             {actionLoading ? (
// //               <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
// //             ) : (
// //               "❌ Reject Update"
// //             )}
// //           </Button>
// //           <Button
// //             variant="success"
// //             onClick={handleApproveUpdate}
// //             disabled={actionLoading}
// //           >
// //             {actionLoading ? (
// //               <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
// //             ) : (
// //               "✅ Approve Update"
// //             )}
// //           </Button>
// //         </Modal.Footer>
// //       </Modal>
// //     </div>
// //   );
// // };

// // export default PendingCompanyProfileUpdatesPage;



// // src/pages/admin/PendingCompanyProfileUpdatesPage.jsx
// import React, { useEffect, useState } from "react";
// import {
//   getPendingCompanyUpdates,
//   approveCompanyProfileUpdate,
//   rejectCompanyProfileUpdate,
// } from "../../../services/adminService";
// import {
//   Button,
//   Table,
//   Spinner,
//   Alert,
//   Badge,
//   Modal,
//   Row,
//   Col,
//   ListGroup,
// } from "react-bootstrap";
// import { format } from "date-fns";
// import { useNavigate } from "react-router-dom";

// const PendingCompanyProfileUpdatesPage = () => {
//   const [pendingCompanies, setPendingCompanies] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [selectedCompanyForReview, setSelectedCompanyForReview] = useState(null);
//   const [showReviewModal, setShowReviewModal] = useState(false);
//   const [actionLoading, setActionLoading] = useState(false);

//   const [search, setSearch] = useState(""); // 🔍 SEARCH STATE ADDED
//   const navigate = useNavigate();

//   const daysOfWeek = [
//     "sunday",
//     "Monday",
//     "tuesday",
//     "wednesday",
//     "thursday",
//     "friday",
//     "saturday",
//   ];

//   const fetchPendingUpdates = async () => {
//     setLoading(true);
//     setError("");
//     try {
//       const res = await getPendingCompanyUpdates();
//       const filtered = res.data.filter(
//         (company) =>
//           company.companyStatus === "pending_update" &&
//           company.pendingProfileUpdates
//       );
//       setPendingCompanies(filtered || []);
//     } catch (err) {
//       setError(
//         err.response?.data?.message ||
//           "Failed to fetch pending company updates."
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPendingUpdates();
//   }, []);

//   // 🔥 SEARCH FILTER LOGIC
//   const filteredCompanies = pendingCompanies.filter((company) => {
//     const term = search.toLowerCase();

//     return (
//       company.name?.toLowerCase().includes(term) ||
//       company.email?.toLowerCase().includes(term) ||
//       company.registeredBy?.name?.toLowerCase().includes(term) ||
//       (company.updatedAt &&
//         format(new Date(company.updatedAt), "PPP p")
//           .toLowerCase()
//           .includes(term))
//     );
//   });

//   const handleReviewClick = (company) => {
//     setSelectedCompanyForReview(company);
//     setShowReviewModal(true);
//   };

//   const handleCloseReviewModal = () => {
//     setSelectedCompanyForReview(null);
//     setShowReviewModal(false);
//     setError("");
//   };

//   const handleApproveUpdate = async () => {
//     if (!selectedCompanyForReview) return;
//     setActionLoading(true);
//     setError("");
//     try {
//       await approveCompanyProfileUpdate(selectedCompanyForReview._id);
//       fetchPendingUpdates();
//       handleCloseReviewModal();
//     } catch (err) {
//       setError(
//         err.response?.data?.message || "Failed to approve company update."
//       );
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const handleRejectUpdate = async () => {
//     if (!selectedCompanyForReview) return;
//     setActionLoading(true);
//     setError("");
//     try {
//       await rejectCompanyProfileUpdate(selectedCompanyForReview._id);
//       fetchPendingUpdates();
//       handleCloseReviewModal();
//     } catch (err) {
//       setError(
//         err.response?.data?.message || "Failed to reject company update."
//       );
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const renderValueComparison = (
//     field,
//     originalValue,
//     pendingValue,
//     type = "text"
//   ) => {
//     const isChanged =
//       JSON.stringify(originalValue) !== JSON.stringify(pendingValue);

//     const renderContent = (value) => {
//       if (value === null || value === undefined || value === "")
//         return <em className="text-muted">N/A</em>;

//       switch (type) {
//         case "url":
//           return (
//             <a href={value} target="_blank" rel="noopener noreferrer">
//               {value}
//             </a>
//           );
//         case "array":
//           return Array.isArray(value) && value.length > 0 ? (
//             value.join(", ")
//           ) : (
//             <em className="text-muted">None</em>
//           );
//         case "object-name":
//           return value?.name || <em className="text-muted">N/A</em>;
//         case "document-link":
//           return (
//             <a href={value} target="_blank" rel="noopener noreferrer">
//               View Document
//             </a>
//           );
//         case "image-link":
//           return (
//             <a href={value} target="_blank" rel="noopener noreferrer">
//               <img
//                 src={value}
//                 alt="Current"
//                 style={{ maxWidth: "80px", maxHeight: "80px" }}
//               />
//             </a>
//           );
//         case "image-array":
//           return Array.isArray(value) && value.length > 0 ? (
//             <div className="d-flex flex-wrap gap-2">
//               {value.map((img, idx) => (
//                 <a
//                   key={idx}
//                   href={img}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <img
//                     src={img}
//                     alt=""
//                     style={{ maxWidth: "50px", maxHeight: "50px" }}
//                   />
//                 </a>
//               ))}
//             </div>
//           ) : (
//             <em className="text-muted">None</em>
//           );
//         default:
//           return value.toString();
//       }
//     };

//     return (
//       <Col xs={12} className="mb-2">
//         <strong className="text-capitalize">
//           {field.replace(/([A-Z])/g, " $1").trim()}:
//         </strong>
//         <Row>
//           <Col xs={6}>
//             <small className="text-muted">Current:</small>
//             <div className={`p-2 border rounded ${isChanged ? "bg-light" : ""}`}>
//               {renderContent(originalValue)}
//             </div>
//           </Col>
//           <Col xs={6}>
//             <small className="text-muted">Proposed:</small>
//             <div
//               className={`p-2 border rounded ${
//                 isChanged ? "bg-warning-subtle fw-bold" : ""
//               }`}
//             >
//               {renderContent(pendingValue)}
//             </div>
//           </Col>
//         </Row>
//       </Col>
//     );
//   };

//   return (
//     <div className="container mt-4">
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <h2 className="fw-bold">🔄 Company Profile Update Requests</h2>

//         <Button variant="primary" onClick={() => navigate("/AdminProductManagementPage")}>
//           Manage All Products
//         </Button>
//       </div>

//       {/* 🔍 SEARCH BAR */}
//       <div className="mb-3 d-flex justify-content-end">
//         <input
//           type="text"
//           className="form-control w-50"
//           placeholder="🔍 Search company name, email, registered by, date..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//         />
//       </div>

//       {error && <Alert variant="danger">{error}</Alert>}

//       {loading ? (
//         <div className="text-center">
//           <Spinner animation="border" />
//           <p>Fetching pending updates...</p>
//         </div>
//       ) : (
//         <Table striped bordered hover responsive className="text-center shadow-sm">
//           <thead className="table-dark">
//             <tr>
//               <th>#</th>
//               <th>Company Name</th>
//               <th>Email</th>
//               <th>Registered By</th>
//               <th>Request Date</th>
//               <th>Actions</th>
//             </tr>
//           </thead>

//           <tbody>
//             {filteredCompanies.length > 0 ? (
//               filteredCompanies.map((company, index) => (
//                 <tr key={company._id}>
//                   <td>{index + 1}</td>
//                   <td>{company.name}</td>
//                   <td>{company.email}</td>
//                   <td>{company.registeredBy?.name || "N/A"}</td>
//                   <td>
//                     {company.updatedAt ? (
//                       format(new Date(company.updatedAt), "PPP p")
//                     ) : (
//                       <em className="text-muted">N/A</em>
//                     )}
//                   </td>
//                   <td>
//                     <Button size="sm" variant="info" onClick={() => handleReviewClick(company)}>
//                       📝 Review Update
//                     </Button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="6" className="text-muted">
//                   No pending company profile updates found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </Table>
//       )}

//       {/* Review Modal */}
//       <Modal show={showReviewModal} onHide={handleCloseReviewModal} size="lg" centered scrollable>
//         <Modal.Header closeButton>
//           <Modal.Title>Review Company Profile Update</Modal.Title>
//         </Modal.Header>

//         <Modal.Body style={{ maxHeight: "75vh", overflowY: "auto" }}>
//           {selectedCompanyForReview && (
//             <>
//               {error && <Alert variant="danger">{error}</Alert>}

//               <h4>
//                 {selectedCompanyForReview.name}
//                 <Badge bg="warning" className="ms-2">
//                   Pending Update
//                 </Badge>
//               </h4>

//               <Alert variant="info">
//                 Current Value (left) vs Proposed Value (right).  
//                 Changed fields are highlighted.
//               </Alert>

//               <Row>
//                 {renderValueComparison(
//                   "name",
//                   selectedCompanyForReview.name,
//                   selectedCompanyForReview.pendingProfileUpdates.name
//                 )}

//                 {renderValueComparison(
//                   "tagline",
//                   selectedCompanyForReview.tagline,
//                   selectedCompanyForReview.pendingProfileUpdates.tagline
//                 )}

//                 {/* ... (rest fields continue same as your original code) */}
//               </Row>
//             </>
//           )}
//         </Modal.Body>

//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCloseReviewModal}>
//             Close
//           </Button>
//           <Button variant="danger" onClick={handleRejectUpdate} disabled={actionLoading}>
//             ❌ Reject Update
//           </Button>
//           <Button variant="success" onClick={handleApproveUpdate} disabled={actionLoading}>
//             ✅ Approve Update
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default PendingCompanyProfileUpdatesPage;


import React, { useEffect, useState } from "react";
import {
  getPendingCompanyUpdates,
  approveCompanyProfileUpdate,
  rejectCompanyProfileUpdate,
} from "../../../services/adminService";
import {
  Button,
  Table,
  Spinner,
  Alert,
  Badge,
  Modal,
  Row,
  Col,
  ListGroup, // Make sure ListGroup is imported
  InputGroup, // For search bar styling
  FormControl // For search bar styling
} from "react-bootstrap";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";

const PendingCompanyProfileUpdatesPage = () => {
  const [pendingCompanies, setPendingCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedCompanyForReview, setSelectedCompanyForReview] = useState(null);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);

  const [search, setSearch] = useState(""); // 🔍 SEARCH STATE ADDED
  const navigate = useNavigate();

  // Normalized days of the week to match API casing for businessTimings
  const daysOfWeek = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];

  const fetchPendingUpdates = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await getPendingCompanyUpdates();
      const filtered = res.data.filter(
        (company) =>
          company.companyStatus === "pending_update" &&
          company.pendingProfileUpdates
      );
      setPendingCompanies(filtered || []);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Failed to fetch pending company updates."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingUpdates();
  }, []);

  // 🔥 SEARCH FILTER LOGIC
  const filteredCompanies = pendingCompanies.filter((company) => {
    const term = search.toLowerCase();

    return (
      company.name?.toLowerCase().includes(term) ||
      company.email?.toLowerCase().includes(term) ||
      company.registeredBy?.name?.toLowerCase().includes(term) ||
      (company.updatedAt &&
        format(new Date(company.updatedAt), "PPP p")
          .toLowerCase()
          .includes(term))
    );
  });

  const handleReviewClick = (company) => {
    setSelectedCompanyForReview(company);
    setShowReviewModal(true);
  };

  const handleCloseReviewModal = () => {
    setSelectedCompanyForReview(null);
    setShowReviewModal(false);
    setError("");
  };

  const handleApproveUpdate = async () => {
    if (!selectedCompanyForReview) return;
    setActionLoading(true);
    setError("");
    try {
      await approveCompanyProfileUpdate(selectedCompanyForReview._id);
      fetchPendingUpdates();
      handleCloseReviewModal();
    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to approve company update."
      );
    } finally {
      setActionLoading(false);
    }
  };

  const handleRejectUpdate = async () => {
    if (!selectedCompanyForReview) return;
    setActionLoading(true);
    setError("");
    try {
      await rejectCompanyProfileUpdate(selectedCompanyForReview._id);
      fetchPendingUpdates();
      handleCloseReviewModal();
    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to reject company update."
      );
    } finally {
      setActionLoading(false);
    }
  };

  const renderValueComparison = (
    field,
    originalValue,
    pendingValue,
    type = "text"
  ) => {
    const isChanged =
      JSON.stringify(originalValue) !== JSON.stringify(pendingValue);

    const renderContent = (value) => {
      if (value === null || value === undefined || value === "")
        return <em className="text-muted">N/A</em>;

      switch (type) {
        case "url":
          return (
            <a href={value} target="_blank" rel="noopener noreferrer">
              {value}
            </a>
          );
        case "array":
          return Array.isArray(value) && value.length > 0 ? (
            value.join(", ")
          ) : (
            <em className="text-muted">None</em>
          );
        case "object-name":
          return value?.name || <em className="text-muted">N/A</em>;
        case "document-link":
          return (
            <a href={value} target="_blank" rel="noopener noreferrer">
              View Document
            </a>
          );
        case "image-link":
          return (
            <a href={value} target="_blank" rel="noopener noreferrer">
              <img
                src={value}
                alt="Current"
                style={{ maxWidth: "80px", maxHeight: "80px" }}
              />
            </a>
          );
        case "image-array":
          return Array.isArray(value) && value.length > 0 ? (
            <div className="d-flex flex-wrap gap-2">
              {value.map((img, idx) => (
                <a
                  key={idx}
                  href={img}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={img}
                    alt=""
                    style={{ maxWidth: "50px", maxHeight: "50px", objectFit: "cover" }}
                  />
                </a>
              ))}
            </div>
          ) : (
            <em className="text-muted">None</em>
          );
        case "business-timings":
          if (!value) return <em className="text-muted">N/A</em>;
          return (
            <ListGroup variant="flush" className="bg-transparent">
              {daysOfWeek.map((day) => (
                <ListGroup.Item key={day} className="d-flex justify-content-between p-1 bg-transparent border-0">
                  <strong className="text-capitalize">{day}:</strong>
                  {value[day]?.open === "Closed" ? (
                    <span>Closed</span>
                  ) : value[day]?.open && value[day]?.close ? (
                    <span>{value[day].open} - {value[day].close}</span>
                  ) : (
                    <em className="text-muted">N/A</em>
                  )}
                </ListGroup.Item>
              ))}
            </ListGroup>
          );
        default:
          return value.toString();
      }
    };

    return (
      <Col xs={12} className="mb-2">
        <strong className="text-capitalize">
          {field.replace(/([A-Z])/g, " $1").trim()}:
        </strong>
        <Row>
          <Col xs={6}>
            <small className="text-muted">Current:</small>
            <div className={`p-2 border rounded ${isChanged ? "bg-light" : ""}`}>
              {renderContent(originalValue)}
            </div>
          </Col>
          <Col xs={6}>
            <small className="text-muted">Proposed:</small>
            <div
              className={`p-2 border rounded ${
                isChanged ? "bg-warning-subtle fw-bold" : ""
              }`}
            >
              {renderContent(pendingValue)}
            </div>
          </Col>
        </Row>
      </Col>
    );
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="fw-bold">🔄 Company Profile Update Requests</h2>

        <Button variant="primary" onClick={() => navigate("/AdminProductManagementPage")}>
          Manage All Products
        </Button>
      </div>

      {/* 🔍 SEARCH BAR */}
      <div className="mb-3 d-flex justify-content-end">
        <InputGroup className="w-50">
          <FormControl
            type="text"
            placeholder="🔍 Search company name, email, registered by, date..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </InputGroup>
      </div>

      {error && <Alert variant="danger">{error}</Alert>}

      {loading ? (
        <div className="text-center">
          <Spinner animation="border" />
          <p>Fetching pending updates...</p>
        </div>
      ) : (
        <Table striped bordered hover responsive className="text-center shadow-sm">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Company Name</th>
              <th>Email</th>
              <th>Registered By</th>
              <th>Request Date</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {filteredCompanies.length > 0 ? (
              filteredCompanies.map((company, index) => (
                <tr key={company._id}>
                  <td>{index + 1}</td>
                  <td>{company.name}</td>
                  <td>{company.email}</td>
                  <td>{company.registeredBy?.name || "N/A"}</td>
                  <td>
                    {company.updatedAt ? (
                      format(new Date(company.updatedAt), "PPP p")
                    ) : (
                      <em className="text-muted">N/A</em>
                    )}
                  </td>
                  <td>
                    <Button size="sm" variant="info" onClick={() => handleReviewClick(company)}>
                      📝 Review Update
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-muted">
                  No pending company profile updates found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}

      {/* Review Modal */}
      <Modal show={showReviewModal} onHide={handleCloseReviewModal} size="lg" centered scrollable>
        <Modal.Header closeButton>
          <Modal.Title>Review Company Profile Update</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ maxHeight: "75vh", overflowY: "auto" }}>
          {selectedCompanyForReview && (
            <>
              {error && <Alert variant="danger">{error}</Alert>}

              <h4>
                {selectedCompanyForReview.name}
                <Badge bg="warning" className="ms-2">
                  Pending Update
                </Badge>
              </h4>

              <Alert variant="info">
                Current Value (left) vs Proposed Value (right).  
                Changed fields are highlighted.
              </Alert>

              <Row>
                {selectedCompanyForReview.pendingProfileUpdates &&
                  Object.keys(selectedCompanyForReview.pendingProfileUpdates).map((key) => {
                    const originalValue = selectedCompanyForReview[key];
                    const pendingValue = selectedCompanyForReview.pendingProfileUpdates[key];

                    let type = "text"; // Default type

                    switch (key) {
                      case "banner":
                      case "photos":
                        type = "image-array";
                        break;
                      case "logo":
                      case "aadhaarImage":
                      case "electricityBillImage":
                      case "passportPhoto":
                        type = "image-link";
                        break;
                      case "website":
                      case "googleMapsLink":
                        type = "url";
                        break;
                      case "category":
                      case "subCategory":
                      case "registeredBy": // Assuming registeredBy could also be an object with a 'name'
                        type = "object-name";
                        break;
                      case "keywords":
                      case "socialLinks":
                        type = "array";
                        break;
                      case "businessTimings":
                        type = "business-timings";
                        break;
                      // Add more cases for other special types if needed
                      default:
                        type = "text"; // Fallback for any other field not explicitly handled
                    }
                    return renderValueComparison(key, originalValue, pendingValue, type);
                  })}
              </Row>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseReviewModal}>
            Close
          </Button>
          <Button variant="danger" onClick={handleRejectUpdate} disabled={actionLoading}>
            ❌ Reject Update
          </Button>
          <Button variant="success" onClick={handleApproveUpdate} disabled={actionLoading}>
            ✅ Approve Update
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PendingCompanyProfileUpdatesPage;